/**
 * Settings Placeholder Page
 *
 * Temporary placeholder for the new MVP settings page
 * Shown while the simplified settings interface is being built
 */

import { Link } from 'react-router-dom';
import { Settings, Wrench, ArrowRight } from 'lucide-react';

export default function SettingsPlaceholder() {
  // Show link to legacy settings only in development
  const showLegacyLink = import.meta.env.DEV;

  return (
    <div className="min-h-screen bg-warm-bg flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-xl shadow-lg border border-slate-200 p-8 md:p-12">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="bg-warm-bg-subtle rounded-full p-6">
              <Settings className="h-12 w-12 text-warm-text" />
            </div>
          </div>

          {/* Heading */}
          <h1 className="font-perfectly-nineties text-4xl font-bold text-center text-warm-text mb-4">
            New Settings Coming Soon
          </h1>

          {/* Description */}
          <p className="text-center text-slate-600 text-lg mb-8">
            We're building a simplified settings experience focused on the essentials.
            The new settings page will be available soon.
          </p>

          {/* Under Construction Notice */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <div className="flex items-start space-x-3">
              <Wrench className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-amber-900 mb-1">
                  Under Construction
                </h3>
                <p className="text-sm text-amber-800">
                  This page is currently being redesigned to provide a cleaner, more
                  focused community management experience.
                </p>
              </div>
            </div>
          </div>

          {/* Development-only legacy link */}
          {showLegacyLink && (
            <div className="border-t border-slate-200 pt-6 mt-6">
              <p className="text-sm text-slate-500 mb-3 text-center">
                Development Mode Only
              </p>
              <Link
                to="/legacy-settings"
                className="flex items-center justify-center space-x-2 text-warm-text hover:text-warm-text/80 transition-colors"
              >
                <span className="font-medium">Access Legacy Settings</span>
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          )}
        </div>

        {/* Additional Info */}
        <p className="text-center text-sm text-slate-500 mt-6">
          Questions? Contact support for assistance.
        </p>
      </div>
    </div>
  );
}
